import gql from 'graphql-tag';

export default gql`
  mutation createMenuItemMutation($input: CreateMenuItemInput!) {
    createMenuItem(input: $input) {
      id
      name
      menuItems {
        name
        id
        price
        itemType
      }
    }
  }
`;
